var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("入库管理")]),
            ]),
            (!this.$route.params ? false : this.$route.params.type)
              ? _c(
                  "el-breadcrumb-item",
                  {
                    attrs: { to: { path: "/logisticsSystem/addStorageList" } },
                  },
                  [
                    _c("div", { staticClass: "div1" }, [
                      _vm._v(" 采购入库列表 "),
                    ]),
                  ]
                )
              : _vm._e(),
            _c("el-breadcrumb-item", { attrs: { to: { path: "/addGoods" } } }, [
              _c("div", { staticClass: "div2" }, [_vm._v("商品详情")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "baisc" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("基本信息")]),
        _c(
          "el-form",
          { staticClass: "demo-form-inline", attrs: { model: _vm.baisc } },
          [
            _c(
              "div",
              { staticClass: "nav" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "商品主图" } },
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "upload",
                        staticClass: "upload-demo",
                        attrs: {
                          "list-type": "picture",
                          action: "#",
                          "show-file-list": false,
                          "auto-upload": true,
                          "http-request": _vm.safeImport,
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "trigger",
                              size: "small",
                              type: "primary",
                            },
                            slot: "trigger",
                          },
                          [_vm._v("点击上传")]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "notes" }, [
                      _c("p", [
                        !_vm.is_null(_vm.imageUrl)
                          ? _c("img", {
                              directives: [
                                {
                                  name: "image-preview",
                                  rawName: "v-image-preview",
                                },
                              ],
                              staticClass: "avatar",
                              attrs: { src: _vm.ImgHttps + _vm.imageUrl },
                            })
                          : _vm._e(),
                        !_vm.is_null(_vm.imageUrl)
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.close(_vm.index)
                                  },
                                },
                              },
                              [_vm._v("×")]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "stock" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品标题", "label-width": "70px" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入商品标题",
                          },
                          model: {
                            value: _vm.baisc.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.baisc, "title", $$v)
                            },
                            expression: "baisc.title",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "选择品牌" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择产品品牌" },
                        model: {
                          value: _vm.baisc.brand,
                          callback: function ($$v) {
                            _vm.$set(_vm.baisc, "brand", $$v)
                          },
                          expression: "baisc.brand",
                        },
                      },
                      _vm._l(_vm.brandselect, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { label: items.name, value: items.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "品牌分类" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.options,
                        props: {
                          checkStrictly: true,
                          label: "name",
                          value: "id",
                          children: "children",
                        },
                        clearable: "",
                      },
                      model: {
                        value: _vm.baisc.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.baisc, "category", $$v)
                        },
                        expression: "baisc.category",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "guige" }, [
              _c("p", { staticClass: "header" }, [_vm._v("规格价格")]),
              _c(
                "div",
                { staticClass: "standards" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品规格" } },
                    _vm._l(_vm.commDictonary, function (items) {
                      return _c(
                        "el-radio-group",
                        {
                          key: items.id,
                          staticStyle: { "margin-right": "10px" },
                          model: {
                            value: _vm.baisc.resource,
                            callback: function ($$v) {
                              _vm.$set(_vm.baisc, "resource", $$v)
                            },
                            expression: "baisc.resource",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: items.id } }, [
                            _vm._v(_vm._s(items.name)),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "stock" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品重量", "label-width": "70px" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入商品重量" },
                            model: {
                              value: _vm.baisc.weight,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "weight", $$v)
                              },
                              expression: "baisc.weight",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.baisc.resource == "件"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "商品数量",
                                "label-width": "70px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入商品一件的总量" },
                                model: {
                                  value: _vm.baisc.number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.baisc, "number", $$v)
                                  },
                                  expression: "baisc.number",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品价格", "label-width": "70px" } },
                    [
                      _c(
                        "div",
                        { staticClass: "price" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "优惠价" },
                            model: {
                              value: _vm.baisc.newPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "newPrice", $$v)
                              },
                              expression: "baisc.newPrice",
                            },
                          }),
                          _c("span", [_vm._v("元")]),
                          _c("el-input", {
                            attrs: { placeholder: "市场价" },
                            model: {
                              value: _vm.baisc.oldPrice,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "oldPrice", $$v)
                              },
                              expression: "baisc.oldPrice",
                            },
                          }),
                          _c("span", [_vm._v("元")]),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "stock" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品库存", "label-width": "70px" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入商品库存" },
                            model: {
                              value: _vm.baisc.stock,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "stock", $$v)
                              },
                              expression: "baisc.stock",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品仓库" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择商品仓库" },
                              model: {
                                value: _vm.baisc.wareHouse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.baisc, "wareHouse", $$v)
                                },
                                expression: "baisc.wareHouse",
                              },
                            },
                            _vm._l(_vm.house, function (items) {
                              return _c("el-option", {
                                key: items.id,
                                attrs: { value: items.id, label: items.name },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品介绍" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.baisc.desc,
                          callback: function ($$v) {
                            _vm.$set(_vm.baisc, "desc", $$v)
                          },
                          expression: "baisc.desc",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "stock" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { label: "推荐商品" },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 0, "inactive-value": 1 },
                            model: {
                              value: _vm.baisc.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "status", $$v)
                              },
                              expression: "baisc.status",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { label: "是否有赠品" },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 0, "inactive-value": 1 },
                            model: {
                              value: _vm.baisc.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "status", $$v)
                              },
                              expression: "baisc.status",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { label: "是否绑定赠品" },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 0, "inactive-value": 1 },
                            model: {
                              value: _vm.baisc.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "status", $$v)
                              },
                              expression: "baisc.status",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { label: "是否为赠品" },
                        },
                        [
                          _c("el-switch", {
                            attrs: { "active-value": 0, "inactive-value": 1 },
                            model: {
                              value: _vm.baisc.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.baisc, "status", $$v)
                              },
                              expression: "baisc.status",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.baisc.status
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "绑定赠品" } },
                        [
                          _c("el-cascader", {
                            attrs: {
                              options: _vm.optionsChexck,
                              type: "textarea",
                              props: {
                                multiple: true,
                                checkStrictly: true,
                                label: "title",
                                value: "id",
                                children: "children",
                              },
                              clearable: "",
                            },
                            model: {
                              value: _vm.giftId,
                              callback: function ($$v) {
                                _vm.giftId = $$v
                              },
                              expression: "giftId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "jurisdictionBox" }, [
                _c("p", { staticClass: "header" }, [_vm._v("销售权限")]),
                _c(
                  "div",
                  { staticClass: "jurisdiction" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "可以销售" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.checkedCities,
                              callback: function ($$v) {
                                _vm.checkedCities = $$v
                              },
                              expression: "checkedCities",
                            },
                          },
                          _vm._l(_vm.selectList, function (city) {
                            return _c(
                              "el-checkbox",
                              {
                                key: city.dictId,
                                attrs: { label: city.dictId },
                              },
                              [_vm._v(_vm._s(city.dictName))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.tolist },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }